import { useEffect } from 'react'
import { BasePathProvider, useSession } from 'components/Providers'
import GradeFilter from './GradeFilter'
import GradeComments from './GradeComments'
import GradeList from './GradeList'
import { Box, Drawer } from '@mui/material'
import FormIndex from './Form'
import { useNavigate, useParams } from 'react-router-dom'
import { search } from 'store/teacher/standard-based';
import { search as searchFinalGrades } from 'store/attendance/final-grades';
import { getGradeLetters } from 'store/lookup'; 
import { useDispatch, useSelector } from 'react-redux'

export default function Grades({ courseSessionList, studentList }) {
  const basePath = `academic/my-courses/grades`
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const { academicYear } = useSession();
  
  const studentStandardBasedGrades = useSelector((state) => state.teacher.standardBased.list);
  const selectedTerm = useSelector((state) => state.academic.courseSession.selectedTerm);
  const selectedStudent = useSelector((state) => state.academic.courseSession.selectedStudent);
  const selectedCourseSession = useSelector((state) => state.academic.courseSession.selectedCourseSession);

  const gradeLetters = useSelector((state) => state.lookup?.gradeLetters || []); 
  const finalGradesList = useSelector((state) => state.academic?.finalGrades?.list || []);
  
  const markingPeriods = academicYear?.markingPeriods || [];

  useEffect(() => {
    const gradingScaleId = selectedCourseSession?.course?.gradingScaleId || selectedCourseSession?.gradingScaleId || 700752;
    
    if (gradingScaleId) {
       dispatch(getGradeLetters({ gradingScaleId }));
    }
  }, [dispatch, selectedCourseSession]);

  useEffect(() => {
    if (selectedStudent?.id) {
      dispatch(search({ courseSessionEnrollmentId: selectedStudent.id }));
    }
  }, [dispatch, selectedStudent?.id]);

  useEffect(() => {
    const courseSessionId = selectedCourseSession?.id || selectedCourseSession?.course?.id;
    if (courseSessionId) {
        dispatch(searchFinalGrades({ courseSessionId }));
    }
  }, [dispatch, selectedCourseSession]);

  return (
    <BasePathProvider value={basePath}>
      <Box backgroundColor='background.paper' sx={{ p: 2, mb: 1, width: '100%' }}>
        <GradeFilter
          selectedCourseSession={selectedCourseSession}
          courseSessionList={courseSessionList}
          studentList={studentList}
          selectedTerm={selectedTerm}
          academicYear={academicYear}
          selectedStudent={selectedStudent}
        />
        <GradeComments 
            finalGradesList={finalGradesList}
            selectedStudent={selectedStudent}
            selectedTerm={selectedTerm}
            gradeLetters={gradeLetters}
        />
        <GradeList 
          studentStandardBasedGrades={studentStandardBasedGrades} 
          markingPeriods={markingPeriods} 
          gradeLetters={gradeLetters} 
        />
      </Box>

      {Boolean(id) && selectedStudent && (
        <Drawer
          anchor="right"
          open
          onClose={() => navigate(`/${basePath}`)}
          PaperProps={{ sx: { width: 800 } }}
        >
          <FormIndex
            selectedTerm={selectedTerm}
            selectedCourseSession={selectedCourseSession}
            selectedStudent={selectedStudent}
            markingPeriods={markingPeriods}
            studentStandardBasedGrades={studentStandardBasedGrades}
          />
        </Drawer>
      )}
    </BasePathProvider>
  )
}